export class PhotoUploaderController {

    constructor($log, $timeout, $window, AppConfig, Upload) {
        'ngInject';

        this.$log = $log;
        this.$timeout = $timeout;
        this.$window = $window;
        this.appConfig = AppConfig;
        this.uploadService = Upload;

        this.image = null;
        this.progress = null;

        this.uploadService.setDefaults({
            ngfMultiple: false,
            ngfPattern: "'image/*'",
            ngfAccept: "'image/*'",
            ngfMaxSize: 20000000
        });
    }

    doUpload(files) {

        this.$log.debug(this.uploadForm, files);

        if (!this.uploadForm.$valid) {
            this.$window.alert('Invalid file type or size, please try again');
            return;
        }

        if (!files.length) return;

        var photo = files[0];

        photo.upload = this.uploadService.upload({
            url: this.appConfig.api_endpoint + '/api/upload-photo',
            data: {
                photo: photo
            },
            ignoreLoadingBar: true
        });

        photo.upload.then((response) => {
            this.progress = null;
            this.image = response.data;
        }, (response) => {
            this.$window.alert('An error occured, please try again');
        }, (evt) => {
            this.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });

    }

    getImage() {
        return this.image;
    }

    deleteImage() {
        this.image = null;
    }

}



// WEBPACK FOOTER //
// ./src/js/components/photo-uploader/photo-uploader.controller.js